export default {
  LOGIN: "{DLL_BASE}/me",
  LEASING_REQUESTS: "{DLL_BASE}/leasing-permission?page={page}&size={size}",
  VIEW_REQUEST: "{DLL_BASE}/leasing-permission/{id}",
  ACCEPT_REQUEST: "{DLL_BASE}/leasing-permission/{id}/approve",
  REJECT_REQUEST: "{DLL_BASE}/leasing-permission/{id}/reject"
};
